export * from './posthog';

// Filter will be used in the context of service.
function filter(target, key, descriptor) {
  const originalMethod = descriptor.value;
  descriptor.value = function (...args) {
    if (
      this.doNotTrack.tenant_id.includes(this.organisationService?.id) ||
      this.organisationService?.id == undefined
    ) {
      return;
    }
    return originalMethod.apply(this, args);
  };

  return descriptor;
}

// Track will be used in the context of service.
export function track(target, propertyKey, descriptor) {
  const originalMethod = descriptor.value; // Store the original function

  descriptor.value = function (...args) {
    if (!this.trackers || !Array.isArray(Object.values(this.trackers))) {
      console.warn('trackers array is missing or invalid');
      return;
    }

    // Loop through all trackers in `this.trackers` and call whatever function
    Object.values(this.trackers).forEach((tracker) => {
      // Bind `this` before passing to `@filter`
      const boundFunction = originalMethod.bind(this, tracker, ...args);

      // Use the filter function on all trackers.
      const filteredFunction = filter(target, propertyKey, {
        value: boundFunction,
      });
      filteredFunction.value.call(this); // Execute the filtered function
    });
  };

  return descriptor;
}
